export default __webpack_public_path__ + "static/media/mongodb.0781b723.svg";